import "./modalRemove.scss";
import ButtonUI from "../../../components/UI/ButtonUI/ButtonUI";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { useContext } from "react";
import { Context } from "../../../index";
import { addFavorite, deleteFavorite } from "../../../http/favoriteApi";

const ModalRemove = ({ closeCallback, basket }) => {
  const { user, settings } = useContext(Context);

  const handleDelete = () => {
    basket.removeAllItems("all");
    closeCallback();
      if (window.turboTarget && window.turboTarget.sendRTGMessage) {
          window.turboTargetPixelRTGClearBasket();
      } else {
          document.addEventListener("generalPixelInited", () => {
              window.turboTargetPixelRTGClearBasket()
          })
      }
  };

  const addProductFavorite = (object) => {
    let currentFavoriteArray = [];
    let currentFavoriteStorage = localStorage.getItem("favoriteStorage");

    if (!currentFavoriteStorage) {
      currentFavoriteArray.push(object);
      let jsonCurrentFavoriteArray = JSON.stringify(currentFavoriteArray);
      if (user.isAuth) {
        addFavorite(object.id, user.user.id);
      }
      localStorage.setItem("favoriteStorage", jsonCurrentFavoriteArray);
    } else {
      currentFavoriteArray = JSON.parse(currentFavoriteStorage);

      let indexItem = 0;
      let isFind = false;

      for (const oneFavoriteItem of currentFavoriteArray) {
        if (oneFavoriteItem.id === object.id) {
          isFind = true;
        }
        indexItem++;
      }

      if (!isFind) {
        if (user.isAuth) {
          addFavorite(object.id, user.user.id);
        }
        currentFavoriteArray.push(object);
      }

      let jsonCurrentFavoriteArray = JSON.stringify(currentFavoriteArray);
      localStorage.setItem("favoriteStorage", jsonCurrentFavoriteArray);

      settings.setFavoriteArray(currentFavoriteArray);
    }
  };

  const handleFavorites = () => {
    basket.basketItems.forEach((item) => {
      const favoriteItem = {
        ...item.item,
        product: {
          ...item.item.product,
          childProducts: [
            {
              id: item.item.id,
              color: item.item.color,
              ...item.item,
            },
          ],
        },

        parrent_price: item.item.product.price,
        child_product_size: item.item.child_product_size,
        child_product_size_field: item.item.child_product_size_field,
      };

      addProductFavorite(favoriteItem);
    });

    basket.removeAllItems("all");
    closeCallback();
  };

  return (
    <div className={"modalRemove"} onClick={closeCallback}>
      <div className="modalRemove__overlay" />
      <div
        className={"modalRemove__container"}
        onClick={(e) => e.stopPropagation()}
      >
        <div onClick={closeCallback} className={"modalRemove__close"}>
          <CloseIcon />
        </div>
        <div className={"modalRemove__body"}>
          <span className={"modalRemove__title"}>Очистить корзину?</span>
          <div className={"modalRemove__controls"}>
            <ButtonUI
              onClick={handleFavorites}
              text={"В избранное"}
              theme="outline"
            />
            <ButtonUI onClick={handleDelete} text={"Очистить"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalRemove;
